import styled from "styled-components/macro";
import { zIndexes } from "../../../utils";

export default styled.div(({ position }) => ({
  position: "fixed",
  top: "0",
  [position]: "0",
  width: "50vw",
  height: "100vh",
  padding: "60px",
  background: "rgba(0,0,0,0.9)",
  color: "red",
  zIndex: zIndexes.modal + 100,
  "& > div": {
    code: { pre: { fontSize: "9px !important" } },
  },
  overflowY: "auto",
}));
